import {
  UploadImageInputTypeV2,
  UploadImageInputV2,
} from '@wajeez-web/components/ui';
import { FieldValues, UseControllerProps } from 'react-hook-form';

import { UploadFileFormType } from '../Types';
import { FormInputController } from '../FormInputController';

export interface UploadImageInputV2Props<TFormFields extends FieldValues>
  extends UseControllerProps<TFormFields>,
    UploadImageInputTypeV2 {
  fieldMeta: UploadFileFormType;
  validationErrorMessages?: Partial<{
    required: string;
  }>;
}

export const FormUploadImageInputV2 = <TFormFields extends FieldValues>({
  name,
  fieldMeta,
  validationErrorMessages,
  readOnly,
  ...props
}: UploadImageInputV2Props<TFormFields>) => {
  return (
    <FormInputController
      name={name}
      fieldMeta={fieldMeta}
      renderInput={({ ...controllerProps }) => (
        <UploadImageInputV2
          label={fieldMeta.label}
          placeholder={fieldMeta.placeHolder}
          required={fieldMeta.required}
          {...controllerProps}
          {...props}
        />
      )}
      {...props}
    />
  );
};
